import React, { useState } from "react";

import useSWR from "swr";

import SearchBar from "../search/SearchBar";
import LoadingAnimation from "../loadingAnimation/loadingAnimation";
import BoardItem from "./board-item/board-item";
import OrderByBar from "../../orderByBar/orderByBar";
import CreateBooking from "../create-booking/CreateBooking";

const Board = ({ order, filter }) => {
  const params = new URLSearchParams({ order });
  if (filter) {
    params.append("filter", filter);
  }
  const { data: bookings, error } = useSWR(`/vacancies?${params}`);

  if (error) {
    return <div>The error occurred.</div>;
  }

  if (!bookings) {
    return <LoadingAnimation />;
  }

  const boardItems = bookings.map(booking => (
    <BoardItem key={booking.vacancyID} vacancy={booking} />
  ));
  return boardItems;
};

const BoardContainer = ({ currentUserEmail }) => {
  const [sortBy, setSortBy] = useState("createdAt");
  const [searchPhrase, setInputValue] = useState("");

  const onChangeHandler = e => {
    setInputValue(e.target.value);
  };

  const onErase = () => {
    setInputValue("");
  };

  const orderByConfig = [
    { value: "Job title", action: () => setSortBy("title") },
    { value: "Start date", action: () => setSortBy("startDate") },
    { value: "Created date", action: () => setSortBy("createdAt") },
    { value: "Status", action: () => setSortBy("state") }
  ];

  return (
    <div className="md:tw-px-20">
      <div className="tw-flex sm:tw-flex-shrink tw-justify-between tw-items-baseline ">
        <div className="tw-flex tw-items-center">
          <SearchBar
            onChangeHandler={onChangeHandler}
            searchPhrase={searchPhrase}
            onErase={onErase}
          />
          <OrderByBar selectConfig={orderByConfig} />
        </div>
        <CreateBooking />
      </div>
      <Board
        order={sortBy}
        filter={searchPhrase}
        currentUserEmail={currentUserEmail}
      />
    </div>
  );
};

export default BoardContainer;
